import React, { FC } from 'react';
import cns from 'classnames';
import Settings from './Settings/Settings';
import Header from './Header/Header';
import Footer from './Footer/Footer';
import InlineStyle from './InlineStyle';
import styles from './Layout.module.scss';
import { adminDomains } from '../../api';
import { useSelector } from 'react-redux';
import { getIsNavmenuButtonsVisibile } from '../../stores/reducers/userData';

interface LayoutType {
  isHeaderSticky?: boolean;
}

const Layout: FC<LayoutType> = ({ children, isHeaderSticky }) => {
  const isPaddingNeeded = useSelector(getIsNavmenuButtonsVisibile);
  
  return (
    <>
      <InlineStyle />
      <Header className={styles.header} isAlwaysSticky={isHeaderSticky} />
      <div
        id="layout"
        className={cns(styles.page, isPaddingNeeded && 'mobile-padding' )}
      >
        <main className={styles.main}>{children}</main>
        {(process.env.NODE_ENV === 'development' || adminDomains.includes(window.location.hostname)) && <Settings />}
      </div>
      <Footer />
    </>
  )
}

export default Layout;
